import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { subspace } from 'redux-subspace';
import hoistNonReactStatics from 'hoist-non-react-statics';
import wrapDisplayName from 'recompose/wrapDisplayName';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * Copyright 2017, IOOF Holdings Limited.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

var SubspaceProvider = /*#__PURE__*/function (_React$PureComponent) {
    inherits(SubspaceProvider, _React$PureComponent);

    function SubspaceProvider() {
        classCallCheck(this, SubspaceProvider);
        return possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    SubspaceProvider.prototype.getChildContext = function getChildContext() {
        var makeSubspaceDecorator = function makeSubspaceDecorator(props) {
            return props.subspaceDecorator || subspace(props.mapState, props.namespace);
        };

        return {
            store: makeSubspaceDecorator(this.props)(this.context.store)
        };
    };

    SubspaceProvider.prototype.render = function render() {
        return Children.only(this.props.children);
    };

    return SubspaceProvider;
}(React.PureComponent);

SubspaceProvider.propTypes = {
    children: PropTypes.element.isRequired,
    mapState: /*#__PURE__*/PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    namespace: PropTypes.string,
    subspaceDecorator: PropTypes.func
};

SubspaceProvider.contextTypes = {
    store: PropTypes.object.isRequired
};

SubspaceProvider.childContextTypes = {
    store: PropTypes.object
};

/**
 * Copyright 2017, IOOF Holdings Limited.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

var subspaced = function subspaced(mapState, namespace) {

    var subspaceDecorator = subspace(mapState, namespace);

    return function (WrappedComponent) {

        var SubspacedComponent = function SubspacedComponent(props) {
            return React.createElement(
                SubspaceProvider,
                { subspaceDecorator: subspaceDecorator },
                React.createElement(WrappedComponent, props)
            );
        };

        hoistNonReactStatics(SubspacedComponent, WrappedComponent);

        SubspacedComponent.displayName = wrapDisplayName(WrappedComponent, 'Subspaced');

        return SubspacedComponent;
    };
};

/**
 * Copyright 2017, IOOF Holdings Limited.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

export { subspaced, SubspaceProvider };
